import script from "./placementStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./placementStatus.vue?vue&type=script&setup=true&lang=js"

import "./placementStatus.vue?vue&type=style&index=0&id=0d696a78&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d696a78"]])

export default __exports__